import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const AccessDenied = () => {
  const { user } = useAuth();

  const getRedirectPath = () => {
    if (user?.role === 'coach') {
      return '/coach/dashboard';
    } else {
      return '/user/chat';
    }
  };

  const getRedirectText = () => {
    if (user?.role === 'coach') {
      return 'Go to Coach Dashboard';
    } else {
      return 'Go to Chat';
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-32 w-32 text-red-500">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-full h-full">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Access Denied
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            You don't have permission to access this page.
          </p>
          {user && (
            <p className="mt-2 text-sm text-gray-500">
              You are logged in as: <span className="font-semibold">{user.name}</span> ({user.role})
            </p>
          )}
        </div>
        <div className="space-y-4">
          <Link
            to={getRedirectPath()}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-accent-green hover:bg-text-greenish focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-green"
          >
            {getRedirectText()}
          </Link>
          <Link
            to="/"
            className="group relative w-full flex justify-center py-2 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            Go to Home Page
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
